import router from './router';
import store from './store';
import { hasLogined, isTwicePwded, isInGame } from './utils';
import { repeatCertify } from '@/api/common';
// 进度条
import NProgress from 'nprogress'; // progress bar
import 'nprogress/nprogress.css'; // progress bar style
NProgress.configure({ showSpinner: false });
/*function isTwicePwded() {
  const token = sessionStorage.getItem('token2')
  //console.log('****'+token)
  if(token)  return true
  return false
}   */
// 开关
let hasAddedRoutes = false;
router.beforeEach(async (to, from, next) => {
  NProgress.start();
  const isToLogin = to.path === '/login';
  const isToCertify = to.name === 'Certify';
  const isHome = from.name === 'Home';
  if (hasLogined()) {
    const userInfo = JSON.parse(sessionStorage.getItem('userInfo') || '{}');
    window.MiniService.UserService.init(isInGame ? 1 : 2, userInfo);
    let data = { uin: userInfo.uin };
    //判断当前路由是否是home
    // 如果已登录的情况，访问登录页，直接跳到首页
    if (isToLogin) {
      if (isTwicePwded()) {
        next({ path: '/' });
      } else {
        if (isToCertify) {
          next({ path: '/' });
        } else {
          let res = await repeatCertify(data);
          //  console.log('---'+res.code)
          if (res.code === 500) {
            next({ name: 'Certify', params: { uin: userInfo.uin } });
          } else {
            next({ path: '/' });
          }
        }
        //  isToCertify ? next() : next({ name: 'Certify', params: { uin: userInfo.uin }})
      }
    } else {
      if (!hasAddedRoutes) {
        hasAddedRoutes = true;
        await store.dispatch('addAsyncRoutes');
        if (isTwicePwded()) {
          next({ ...to });
        } else {
          //    isToCertify ? next({...to}) : next({ name: 'Certify', params: { uin: userInfo.uin }})
          if (isToCertify) {
            next({ ...to });
          } else {
            let res = await repeatCertify(data);
            if (res.code === 500) {
              next({ name: 'Certify', params: { uin: userInfo.uin } });
            } else {
              next({ ...to });
            }
          }
        }
        // router.push({ ...to }); // 修复控制台报 ”Redirected when going from "/login" to "/home" via a navigation guard.“ 问题
      } else {
        if (isTwicePwded()) {
          next();
        } else {
          //  isToCertify ? next() : next({ name: 'Certify', params: { uin: userInfo.uin }})
          if (isToCertify) {
            next();
          } else {
            let res = await repeatCertify(data);
            if (res.code === 500) {
              next({ name: 'Certify', params: { uin: userInfo.uin } });
            } else {
              next();
            }
          }
        }
      }
    }
    // if (isHome) {
    //   next({
    //     ...to,
    //     query: {
    //       ...to.query,
    //       last: 1,
    //     },
    //   });
    // }
    NProgress.done();
  } else {
    // 未登录的情况，允许访问登录页，
    if (isToLogin) {
      next();
    } else {
      next({ path: '/login' });
    }
    NProgress.done();

    // 退出时重置开关
    hasAddedRoutes = false;
  }
});

router.afterEach(() => {
  NProgress.done();
});
